export default __webpack_public_path__ + "static/media/owned-icon.cf98c2d0.svg";